export function getDisplayedFigures(number, displayedFigures) {
    if (typeof number !== "number") {
        return null
    }
    const digitsBeforeDecimal = number.toString().split(".")[0]
    return parseFloat(number.toFixed(displayedFigures - digitsBeforeDecimal.length))
}